<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 211.145"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            d="M44.566 79.445c3.314,0.767 6.648,1.023 10.001,0.77 -0.354,24.362 0.37,59.232 -0.769,98.857 -5.204,-32.209 -8.281,-65.418 -9.232,-99.627z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M56.473 15.728c-5.217,0.374 -10.165,0.167 -14.845,-0.621 -3.961,-0.667 -7.73,-1.751 -11.307,-3.25 5.515,-4.571 12.761,-7.41 20.935,-7.478 9.599,-0.081 17.317,2.976 22.552,8.244 -6.074,1.677 -11.853,2.712 -17.335,3.105z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M42.405 45.058c-0.662,-9.334 -0.921,-19.318 -0.777,-29.951 4.68,0.788 9.628,0.995 14.845,0.621 2.023,13.7 2.157,23.615 0.402,29.747 -4.706,-1.193 -9.529,-1.332 -14.47,-0.417z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondLeft}"
            @click="select('secondLeft')"
            d="M41.628 15.107c-0.144,10.633 0.115,20.617 0.777,29.951 -5.81,1.077 -11.782,3.612 -17.917,7.605 -0.319,-0.518 -0.624,-1.045 -0.916,-1.579 -2.634,-4.831 -4.149,-10.301 -4.238,-15.808 -0.149,-9.172 4.048,-17.667 10.987,-23.419 3.577,1.499 7.346,2.583 11.307,3.25z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M42.405 45.058c4.941,-0.915 9.764,-0.776 14.47,0.417 5.748,1.457 11.321,4.489 16.72,9.093 -5.722,7.482 -14.073,12.861 -23.428,13.012 -11.036,0.178 -20.273,-6.124 -25.679,-14.917 6.135,-3.993 12.107,-6.528 17.917,-7.605z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondRight}"
            @click="select('secondRight')"
            d="M56.875 45.475c1.755,-6.132 1.621,-16.047 -0.402,-29.747 5.482,-0.393 11.261,-1.428 17.335,-3.105 4.833,4.863 7.549,11.609 7.676,19.51 0.109,6.744 -2.181,13.865 -6.13,19.941 -0.554,0.853 -1.142,1.686 -1.759,2.494 -5.399,-4.604 -10.972,-7.636 -16.72,-9.093z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M75.354 52.074c1.355,51.676 -3.975,116.768 -15.605,150.27 -10.915,19.631 -20.318,-20.011 -25.131,-76.227 -4.173,-28.853 -3.24,-57.709 -11.046,-75.033m27.684 -46.705c-18.46,0.154 -32.188,14.436 -31.922,30.897 0.266,16.461 13.271,32.587 30.833,32.304 17.561,-0.284 31.583,-18.986 31.317,-35.447 -0.265,-16.461 -11.769,-27.909 -30.228,-27.754z"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]

}
</script>
